__turbopack_context__.v({
  "borderedSection": "form-module-scss-module__mb3Spq__borderedSection",
  "formCheckbox": "form-module-scss-module__mb3Spq__formCheckbox",
  "formError": "form-module-scss-module__mb3Spq__formError",
  "formInnerSection": "form-module-scss-module__mb3Spq__formInnerSection",
  "formInput": "form-module-scss-module__mb3Spq__formInput",
  "formLabel": "form-module-scss-module__mb3Spq__formLabel",
  "formLabel2": "form-module-scss-module__mb3Spq__formLabel2",
  "formLabelIcon": "form-module-scss-module__mb3Spq__formLabelIcon",
  "formWarning": "form-module-scss-module__mb3Spq__formWarning",
  "formWrp": "form-module-scss-module__mb3Spq__formWrp",
  "panelGroupWithTable": "form-module-scss-module__mb3Spq__panelGroupWithTable",
});
